import React from 'react';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  getCurrentPayCycleStartDate,
  isDateInPreviousPayCycle,
  isGridFormValid,
  IsSectionVisible,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import { DataCenterAccountingPayrollColumnList } from '../../constants/MockData';
import _ from 'lodash';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import moment from 'moment';

// Configure Datacenter Payroll
class ConfigureDatacenterPayroll extends React.Component {
  // Constructor to define initial state of component
  constructor(props) {
    super(props);
    this.state = {
      isInAddMode: false,
      configuration: [],
      selectedEditRowId: undefined,
      updateData: {
        multiplier: 0,
        bonus: 0,
        burdenRatePercent: 0,
        type: '',
        applicableFrom: null,
        payrollConfigurationId: 0,
        minDate: getCurrentPayCycleStartDate()
      },
      DataCenterPayrollColumnList: _.clone(DataCenterAccountingPayrollColumnList),
      isDelete: false,
      showWarningMessage: false,
      confirmMessage: '',
      DatacenterPayrollData: []
    };
  }

  // Get data from API before components are mounted
  componentDidMount() {
    this.getMasterData();
  }

  // Get Master data using API
  getMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetDatacenterPayroll,
        key: 'DatacenterPayrollData'
      }
    ])
      .then(({ DatacenterPayrollData }) => {
        this._asyncRequest = null;
        if (DatacenterPayrollData.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
        }

        this.setState({
          DatacenterPayrollData: DatacenterPayrollData.data || [],
          configuration: DatacenterPayrollData.config || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get Datacenter Payroll configuration
  GetDatacenterPayrollData = () => {
    apiRequest({
      url: API_URL.Users.GetDatacenterPayroll
    }).then(({ data: response }) => {
      this.setState({
        DatacenterPayrollData: response || []
      });
    });
  };

  // Handle cancel event
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
  };

  // Check validations
  isValidForm = () => {
    let IsValid = true;
    const { updateData, DataCenterPayrollColumnList } = this.state;
    DataCenterPayrollColumnList.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ DataCenterPayrollColumnList }, this.forceUpdate());
    return IsValid;
  };

  // Check if duplicate entry is exists
  isPayrollExists = () => {
    const { updateData, DatacenterPayrollData } = this.state;
    const existingRecord = DatacenterPayrollData.find(y => moment(y.applicableFrom)
      .format(DateFormat) === moment(updateData.applicableFrom).format(DateFormat) &&
      y.payrollConfigurationId !== updateData.payrollConfigurationId && y.type === updateData.type);
    if (existingRecord !== undefined) {
      const message = 'Applicable From: ' + moment(existingRecord.applicableFrom).format(DateFormat) + ' already exists for ' + existingRecord.type + '. If you want to update any information please edit that particular record.';
      ShowToast(message, toastType.WARNING, 5000, 500);
      return true;
    }
    return false;
  }

  // Click event of save button
  saveUpdatedRecord = () => {
    if (this.isPayrollExists() || !this.isValidForm()) { return false; } else {
      const newParam = this.state.updateData;
      const params = {
        multiplier: newParam.multiplier,
        type: newParam.type,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        payrollConfigurationId: newParam.payrollConfigurationId,
        StatusId: 1
      };
      this.SaveDatacenterPayroll(params);
    };
  }

  // Save Datacenter Payroll configuration into database
  SaveDatacenterPayroll = (params) => {
    apiPost({
      url: API_URL.Users.UpdateDatacenterPayrollConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          isInAddMode: false,
          showWarningMessage: false,
          confirmMessage: ''
        }, () => this.GetDatacenterPayrollData());
      } else {
        ShowToast(response.errorMessage, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Check if Edit icon should display or not
  IsEditVisible = (cellInfo) => {
    if (isDateInPreviousPayCycle(moment(cellInfo.applicableFrom).format(DateFormat))) {
      return false;
    }
    return true;
  }

  // Open record into Edit mode
  EditRecord = (cellInfo) => {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      const DataCenterPayrollColumnList = _.cloneDeep(DataCenterAccountingPayrollColumnList);
      DataCenterPayrollColumnList.forEach(x => {
        if (x.key === 'applicableFrom') {
          x.minDate = getCurrentPayCycleStartDate();
        }
      });
      cellInfo.minDate = getCurrentPayCycleStartDate();
      this.setState({
        selectedEditRowId: { key: 'payrollConfigurationId', value: cellInfo.payrollConfigurationId },
        isInAddMode: false,
        updateData: { ...cellInfo },
        DataCenterPayrollColumnList
      });
    }
  }

  // Render Edit/Update/Cancel action buttons
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.payrollConfigurationId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>{(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PAYROLL_INFO, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
          )}
            {(IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PAYROLL_INFO, SECTIONS.ADD_EDIT)) && this.IsEditVisible(cellInfo) && (
              <Tooltip title="Delete Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.deleteRecord(cellInfo);
                  }}
                >
                  <DeleteIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            )}
          </>
        }
      </>
    );
  };

  /**
 * delete record
 */
  deleteRecord(cellInfo) {
    if (this.state.isInAddMode === true && this.state.updateData !== null) {
      ShowToast('You can modify one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    } else {
      this.setState({
        showWarningMessage: true,
        confirmMessage: 'Do you want to delete this record ?',
        updateData: cellInfo
      });
    }
  };

  /**
 * handle dialog box click event
 * @param {*} e
 */
  onClickHandle(e) {
    if (e) {
      const newParam = this.state.updateData;
      const params = {
        multiplier: newParam.multiplier,
        type: newParam.type,
        bonus: newParam.bonus,
        burdenRatePercent: newParam.burdenRatePercent,
        applicableFrom: moment(newParam.applicableFrom).format(DateFormat),
        payrollConfigurationId: newParam.payrollConfigurationId,
        StatusId: 2
      };
      this.SaveDatacenterPayroll(params);
    } else {
      this.setState({
        showWarningMessage: false,
        confirmMessage: ''
      });
    }
  }

  // Handle edit event of values in table
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { DataCenterPayrollColumnList } = this.state;
    const param = { ...this.state.updateData };

    param[fieldName] = value;
    isGridFormValid(value, DataCenterPayrollColumnList.find(x => x.key === fieldName), param);

    this.setState({ updateData: param });
  };

  // Add new record
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }
    const DataCenterPayrollColumnList = _.cloneDeep(DataCenterAccountingPayrollColumnList);
    DataCenterPayrollColumnList.forEach(x => {
      if (x.key === 'applicableFrom') {
        x.minDate = getCurrentPayCycleStartDate();
      }
    });

    const rowNew = {
      multiplier: 0,
      bonus: 0,
      type: '',
      burdenRatePercent: 0,
      applicableFrom: null,
      payrollConfigurationId: 0,
      minDate: getCurrentPayCycleStartDate()
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'payrollConfigurationId', value: 0 }, updateData: rowNew, DataCenterPayrollColumnList });
  };

  // Render components based on conditions
  render() {
    const { configuration, DatacenterPayrollData, isInAddMode, selectedEditRowId, updateData, DataCenterPayrollColumnList } = this.state;
    const EditSource = [];
    EditSource.push(
      { key: 'typeMasterData', data: [{ type: 'Leadership' }, { type: 'Datacenter Employee' }] }
    );

    return (
      <>
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={(isValid) => { this.onClickHandle(isValid); }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Datacenter Payroll Configuration
                                    </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(DataCenterPayrollColumnList, configuration, [])}
                  data={DatacenterPayrollData}
                  config={DataCenterPayrollColumnList}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={selectedEditRowId}
                  isInAddMode={isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={updateData}
                  isInline={true}
                  AddNewRecord={{ action: this.AddNewRecord, title: 'Add New Datacenter Payroll', visible: IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION, SECTIONS.CONFIGURE_SDC_PAYROLL_INFO, SECTIONS.ADD_EDIT) }}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigureDatacenterPayroll;
